import type { BoardRow } from '../game/types';
import { STAR_PATH } from './Icon';
import { SEQ, d } from '../motion/sequences';

function h(i: number) { const x = Math.sin(i * 91.7 + 3.1) * 43758.5453; return x - Math.floor(x); }
const ordinal = (n: number) => { const s = ['th', 'st', 'nd', 'rd'], v = n % 100; return n + (s[(v - 20) % 10] || s[v] || s[0]); };

/** One-shot star shower (24 stars by default). Deterministic positions so screenshots match. */
export function StarFall({ count = 24, fall = 1000 }: { count?: number; fall?: number }) {
  return (
    <>
      {Array.from({ length: count }, (_, i) => (
        <svg key={i} className="mo-starfall" aria-hidden="true" viewBox="0 0 24 24"
          style={{ position: 'absolute', top: 0, left: `${Math.round(h(i) * 96 + 2)}%`, width: 18 + h(i + 40) * 26, height: 18 + h(i + 40) * 26, color: '#FFCC00',
            ...d(SEQ.finale.steps.stars + Math.round(h(i + 80) * 1800)), ['--fall' as string]: `${Math.round(fall * 0.7 + h(i + 120) * fall * 0.5)}px`, ['--spin' as string]: `${Math.round(h(i + 160) * 360 - 180)}deg` }}>
          <path className="ex-star" d={STAR_PATH} />
        </svg>
      ))}
    </>
  );
}

/** TV podium (2nd, 1st, 3rd). Admissions language; no pass threshold. */
export function Podium({ rows }: { rows: BoardRow[] }) {
  const s = SEQ.finale.steps;
  const slots: [number, number, string, number][] = [[1, 260, '#E9DDC3', s.second], [0, 380, '#FFCC00', s.first], [2, 190, '#D9C9A6', s.third]];
  return (
    <div style={{ flex: 1, display: 'grid', gridTemplateColumns: 'repeat(3, 440px)', gap: 36, alignItems: 'end', width: 'max-content' }}>
      {slots.map(([idx, height, bg, delay]) => {
        const r = rows[idx];
        if (!r) return <div key={idx} />;
        return (
          <div key={r.id} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, minWidth: 0 }}>
            <span className="ex-display mo-rise" style={{ ...d(delay + s.names), fontSize: r.name.length > 20 ? 44 : 60, textAlign: 'center', maxWidth: 440, overflowWrap: 'anywhere', lineHeight: 1.02 }}>{r.name}</span>
            <span className="ex-tnum mo-rise" style={{ ...d(delay + s.names), font: '800 34px/1 var(--font-ui)', color: '#B9C3E6' }}>{r.score} pts</span>
            <div className="mo-podium" style={{ ...d(delay), width: '100%', height, background: bg, color: '#0E1430', borderRadius: '10px 10px 0 0', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 22, gap: 12 }}>
              <span className="ex-display" style={{ fontSize: 96 }}>{ordinal(r.rank)}</span>
              <span className="ex-mono" style={{ fontSize: 18, textAlign: 'center', padding: '0 16px' }}>{r.rank === 1 ? 'Admitted with full honours' : 'Admitted with distinction'}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

/** Decree for an entry. Everyone is admitted; there is no pass threshold. */
export const decreeFor = (rank: number) => rank === 1 ? 'Admitted with full honours' : rank <= 3 ? 'Admitted with distinction' : 'Admitted, pending paperwork';
